import * as React from "react";
import Section from "../../Layout/Section";
import DigitsBackground from "./DigitsBackground";
import * as styles from "./digits.module.css";
import TemplateString from "../../Common/TemplateString";

const Digits = ({title, digits}) => {
    return (
        <Section>
            <div className={styles.digits}>
                <h2 className={styles.digits__title}>
                    <TemplateString template={title} />
                </h2>
                <div className={styles.digits__list}>
                    {digits.map(({id, value, description}) => (
                        <div key={id} className={styles.digits__item}>
                            <h3 className={styles.digits__itemValue}>
                                <TemplateString template={value} />
                            </h3>
                            <p className={styles.digits__itemDesc}>
                                <TemplateString template={description} />
                            </p>
                        </div>
                    ))}
                </div>
                <DigitsBackground />
            </div>
        </Section>
    );
};

export default Digits;
